import React, {ComponentProps} from "react";

function NotFound(props:ComponentProps<any>){
    return (
        <>
            <h1>OOPS! Error 404</h1>
        </>
    )
}
export default NotFound